/* FORM */
// Toujours compléter d'abord pas les exceptions
import { FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY } from 'constants/contactForm7Constants';

export const formClasses = [
  {
    formNames: [''],
    classes: ''
  }
];

export const fieldOnASingleRow = [
  {
    formNames: [''],
    fieldTypeList: ['file', 'hidden'],
    rowClasses: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['textarea'],
    rowClasses: 'input form-contact__textarea'
  },
  {
    formNames: [''],
    fieldTypeList: ['submit'],
    rowClasses: 'input form-action'
  }
];

export const multipleFieldsOnASingleRow = [
  {
    formNames: [''],
    fieldTypeList: ['text', 'email'],
    rowClasses: 'form-contact__row',
    divContainedInRowClasses: 'form-contact__input'
  },
  {
    formNames: [''],
    fieldTypeList: ['select'],
    rowClasses: 'form-contact__row',
    divContainedInRowClasses: ''
  }
];

/*  FIELDS */
export const errorClasses = {
  containerDiv: 'has-error',
  icon: 'icon-info',
  span: 'input__error'
};

export const fieldClasses = [
  {
    formNames: FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY,
    fieldTypeList: ['text', 'text*', 'email', 'email*', 'number', 'number*'],
    fieldContainerDiv: 'input input--light',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['text', 'text*', 'email', 'email*', 'number', 'number*'],
    fieldContainerDiv: 'input input--material',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['textarea', 'textarea*'],
    fieldContainerDiv: 'input input--material input--light',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['file', 'file*'],
    fieldContainerDiv: 'input--file form-contact__file',
    label: '',
    input: ''
  },
  // not used just to try
  {
    formNames: [''],
    fieldTypeList: ['number', 'number*', 'date', 'date*', 'checkbox', 'checkbox*'],
    fieldContainerDiv: '',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['checkbox', 'checkbox*'],
    containerDiv: '',
    fieldContainerDiv: 'checkbox col col-lg-4',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['select', 'select*'],
    containerDiv: 'form-contact__select',
    fieldContainerDiv: 'select js-other',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['submit'],
    fieldContainerDiv: '',
    label: 'btn btn--primary js-contact-send',
    input: '',
    p: 'ft-tertiary ft-black-secondary',
    cancelButton: 'ft-500 ft-black-secondary'
  }
];
